<template>
  <card-with-header-and-footer-component :loading="fonts.loading">
    <template v-slot:header>
      <h3 class="text-lg font-semibold leading-5 text-gray-900 sm:line-clamp-2">{{ $t('customization.desing_fonts') }}</h3>
    </template>

    <p class="text-sm text-gray-500 mb-4">{{ $t('customization.fonts_info') }}</p>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <div>
        <label for="font-h1" class="block text-sm font-medium text-gray-700">{{ $t('customization.font_h1') }}</label>
        <select id="font-h1" name="font-h1" v-model="fonts.request.font_h1" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-bpblue focus:border-bpblue sm:text-sm rounded-md">
          <option v-for="font in fontCatalog" :key="font.slug" :value="font.slug">{{ font.label }}</option>
        </select>
      </div>

      <div>
        <label for="font-h2" class="block text-sm font-medium text-gray-700">{{ $t('customization.font_h2') }}</label>
        <select id="font-h2" name="font-h2" v-model="fonts.request.font_h2" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-bpblue focus:border-bpblue sm:text-sm rounded-md">
          <option v-for="font in fontCatalog" :key="font.slug" :value="font.slug">{{ font.label }}</option>
        </select>
      </div>

      <div>
        <label for="font-h3" class="block text-sm font-medium text-gray-700">{{ $t('customization.font_h3') }}</label>
        <select id="font-h3" name="font-h3" v-model="fonts.request.font_h3" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-bpblue focus:border-bpblue sm:text-sm rounded-md">
          <option v-for="font in fontCatalog" :key="font.slug" :value="font.slug">{{ font.label }}</option>
        </select>
      </div>

      <div>
        <label for="font-body" class="block text-sm font-medium text-gray-700">{{ $t('customization.font_body') }}</label>
        <select id="font-body" name="font-body" v-model="fonts.request.font_body" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-bpblue focus:border-bpblue sm:text-sm rounded-md">
          <option v-for="font in fontCatalog" :key="font.slug" :value="font.slug">{{ font.label }}</option>
        </select>
      </div>
    </div>

    <template v-slot:footer>
      <button type="button" v-on:click="getFonts" :disabled="fonts.loading" class="mr-2 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t('general.cancel') }}
      </button>

      <button type="button" v-on:click="saveFonts" :disabled="fonts.loading" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-bpblue hover:bg-bpbluedeep focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t('general.save') }}
      </button>
    </template>
  </card-with-header-and-footer-component>
</template>

<script>
import CardWithHeaderAndFooterComponent from "@/components/panels/CardWithHeaderAndFooterComponent";
import FontsService from "@/services/academy/FontsService";
import NotificationService from "@/services/notification/NotificationService";
import { useAcademiesStore } from "@/stores/academies";
import loadWhenAcademyReady from "@/mixins/loadWhenAcademyReady";

export default {
  name: "FontsComponent",
  mixins: [loadWhenAcademyReady('getFonts')],
  components: {
    CardWithHeaderAndFooterComponent,
  },
  data () {
    return {
      // Mismo catálogo que ~/app/config/fonts.php — mantener sincronizado si cambia.
      fontCatalog: [
        { slug: '', label: this.$t('customization.font_default') },
        { slug: 'inter', label: 'Inter' },
        { slug: 'roboto', label: 'Roboto' },
        { slug: 'open-sans', label: 'Open Sans' },
        { slug: 'montserrat', label: 'Montserrat' },
        { slug: 'poppins', label: 'Poppins' },
        { slug: 'lato', label: 'Lato' },
        { slug: 'nunito', label: 'Nunito' },
        { slug: 'merriweather', label: 'Merriweather' },
      ],
      fonts: {
        loading: true,
        request: {
          font_h1: "",
          font_h2: "",
          font_h3: "",
          font_body: ""
        }
      },
    }
  },
  setup(){
    const academyStore = useAcademiesStore();

    return {
      academyStore
    }
  },
  methods: {
    getFonts() {
      let academy_uuid = this.academyStore.academy.uuid;
      this.fonts.loading = true;

      FontsService.index(academy_uuid)
          .then((response) => {
            console.log("Se han obtenido las tipografías correctamente", response)
            this.fonts.request = response.data
          })
          .catch((response) => {
            console.log("Error obteniendo los datos de tipografía", response)
            NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
          })
          .finally(() => {
            this.fonts.loading = false
          })
    },
    saveFonts() {
      let academy_uuid = this.academyStore.academy.uuid;
      this.fonts.loading = true;

      FontsService.update(academy_uuid, this.fonts.request)
          .then((response) => {
            console.log("Se han almacenado las tipografías correctamente", response)
            NotificationService.showNotification("Los datos de tipografía se han almacenado correctamente", "success")
          })
          .catch((error) => {
            console.log("Error almacenando las tipografías", error.response)
            if (error.response.data.errors)
            {
              error.response.data.errors.forEach( (error) => {
                NotificationService.showNotification(error, "error")
              })
            }
            else
            {
              NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
            }
          })
          .finally(() => {
            this.fonts.loading = false
          })
    },
  },
}
</script>

<style scoped>

</style>
